import Vue from 'vue'
import Vuexi18n from 'vuex-i18n'

export default {
  configure(store) {
    Vue.use(Vuexi18n.plugin, store)
    const resourcesFR = require('./resources/fr.json')
    const resourcesNL = require('./resources/nl.json')
    const resourcesDE = require('./resources/de.json')
    Vue.i18n.add('fr', resourcesFR)
    Vue.i18n.add('nl', resourcesNL)
    Vue.i18n.add('de', resourcesDE)
    Vue.i18n.set('fr')
  }
}
